import { useNavigate, useQueryState, useRoute } from '@ywwwtseng/react-kit';
import * as schema from '@/db/schema';
import { useWalletKitConnect } from '@ywwwtseng/wallet-kit';
import { useTonWalletKit } from '@ywwwtseng/ton-wallet-kit';
import * as utils from '@/utils';
import { NETWORKS } from '@/constants';

export function useConnectedGuard(
  callback: () => void | Promise<void>,
  options: { verified?: boolean; network?: string | null } = {
    verified: false,
    network: undefined,
  }
) {
  const network = options.network ?? 'bsc';
  const me = useQueryState<typeof schema.users.$inferSelect>('me');
  const route = useRoute();
  const navigate = useNavigate();
  const walletKitConnect = useWalletKitConnect();
  const tonWalletKit = useTonWalletKit();

  return async () => {
    if (!me) {
      throw new Error('Me is not found');
    }

    if (
      options.verified &&
      (walletKitConnect.accounts.solana.status === 'connected' || walletKitConnect.accounts.bsc.status === 'connected' || walletKitConnect.accounts.ethereum.status === 'connected' || tonWalletKit.connected) &&
      utils.app.isNeedVerifyAccount(me)
    ) {
      navigate('AccountVerification0', { params: { back: route.name } });
      return;
    }

    if (network === NETWORKS.TON) {
      if (!tonWalletKit.connected) {
        console.log('connect ton', tonWalletKit.address, me.ton_address);
        await tonWalletKit.connect();
        return;
      } else if (utils.app.isWalletOutOfSync(NETWORKS.TON, me, tonWalletKit.address)) {
        console.log('disconnect and connect ton', tonWalletKit.address, me.ton_address);
        await tonWalletKit.disconnect();
        await tonWalletKit.connect();
        return;
      }
    }

    if (network === NETWORKS.SOLANA) {
      if (walletKitConnect.accounts.solana.status !== 'connected') {
        console.log('connect solana', walletKitConnect.accounts.solana.address, me.sol_address);
        await walletKitConnect.open();
        return;
      } else if (utils.app.isWalletOutOfSync(NETWORKS.SOLANA, me, walletKitConnect.accounts.solana.address)) {
        console.log('disconnect and connect solana', walletKitConnect.accounts.solana.address, me.sol_address);
        await walletKitConnect.disconnect();
        await walletKitConnect.open();
        return;
      }
    }

    if (network === NETWORKS.BSC) {
      if (walletKitConnect.accounts.bsc.status !== 'connected') {
        console.log('connect bsc', walletKitConnect.accounts.bsc.address, me.bsc_address);
        await walletKitConnect.open();
        return;
      } else if (utils.app.isWalletOutOfSync(NETWORKS.BSC, me, walletKitConnect.accounts.bsc.address)) {
        console.log('disconnect and connect bsc', walletKitConnect.accounts.bsc.address, me.bsc_address);
        await walletKitConnect.disconnect();
        await walletKitConnect.open();
        return;
      }
    }

    if (network === NETWORKS.ETHEREUM) {
      if (walletKitConnect.accounts.ethereum.status !== 'connected') {
        console.log('connect ethereum', walletKitConnect.accounts.ethereum.address, me.eth_address);
        await walletKitConnect.open();
        return;
      } else if (utils.app.isWalletOutOfSync(NETWORKS.ETHEREUM, me, walletKitConnect.accounts.ethereum.address)) {
        console.log('disconnect and connect ethereum', walletKitConnect.accounts.ethereum.address, me.eth_address);
        await walletKitConnect.disconnect();
        await walletKitConnect.open();
        return;
      }
    }


    await callback();
  };
}
